import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { Channel } from '../../../models/loyalty-channel.model';
import { StoreModel } from '../../../models/store-common.model';
import { LoyaltyChannelService } from '../../../services/loyalty/loyalty-channel.service';
import { StoreCommonService } from '../../../services/store/store-common.service';
import { Permission } from './../../../models/permission.model';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { PermsService } from './../../../services/utils/perms.service';

@Component({
  selector: 'app-loyalty-channel',
  templateUrl: './loyalty-channel.component.html',
  styleUrls: ['./loyalty-channel.component.css']
})
export class LoyaltyChannelComponent implements OnInit {

  listStates: Array<{value: string, label: string}>;
  stores = new Map<string, StoreModel>();
  completeStore: Array<{ value: string, label: string }>;

  // Mostra tasti di edit, delete e recover
  channelPermission: Permission;

  show = {
    datatable: false
  }

  public selectFilter = KontableComponent.SelectFilter;
  public pagination = KontableComponent.ServerPagination;
  public tableChange = false;

  constructor (
    public channelService: LoyaltyChannelService,
    private router: Router,
    private storeService: StoreCommonService,
    private srvPermission: PermsService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit() {

    this.completeStore = [];
    this.listStates = [];
    this.listStates.push({ label: '', value: null });

    let Translations =  this.srvTranslate.get([
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted'
    ]);

    let Stores = this.storeService.getList();

    let Permissions = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'channel'});

    Observable.zip(
      Translations,
      Stores,
      Permissions
    ).subscribe(([resTranslations, resStores, resPermissions]) => {

      if (this.completeStore.length <= 1) {
        for (const store of resStores) {
          this.stores.set(store.id.toString(), store);
          this.completeStore.push({
            value: store.description,
            label: store.description
          });
        }
      }
      this.completeStore.push({value: null, label: resTranslations['common.all']});
      this.listStates.push({ label: resTranslations['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: resTranslations['common.status_onlyDeleted'], value: '1' });

      this.channelPermission = resPermissions;

      this.show.datatable = true;

    });

  }
  add() {
    this.router.navigate(['/loyalty/channel/form']);
  }

  edit(channel: Channel) {
    this.router.navigate(['/loyalty/channel/form/' + channel.id]);
  }

  remove(channel) {
    this.channelService.remove(channel.id).subscribe(() => {
      this.tableChange = true;
    });
  }

  recover(acmType) {
    this.channelService.recover(acmType).subscribe((res ) => {
      this.tableChange = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-channel/loyalty-channel.component.ts